import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import customBaseTheme from './customBaseTheme';

const muiTheme = getMuiTheme(customBaseTheme);

export default class ThemeWrapper extends React.Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        {this.props.children}
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/themes/ThemeWrapper.js